const adventureAnime = [
    {
      question: "What motivates you the most in your journey?",
      img :"https://img.freepik.com/free-photo/anime-character-traveling_23-2151278739.jpg",
      OPTIONS: {
        "A": "Treasure and riches.",
        "B": "Protecting your loved ones.",
        "C": "Seeking justice and revenge.",
        "D": "Exploring the unknown.",
        "E": "Defeating powerful adversaries.",
        "F": "Achieving personal growth and mastery."
      }
    },
    {
      question:"Which type of environment appeals to you the most?",
      img:"https://i.pinimg.com/736x/06/b4/30/06b430dfbe472217540a1adbbdae3551.jpg",
      OPTIONS: {
        "A": "Vast oceans and islands.",
        "B": "Mystical forests and ancient temples.",
        "C": "Ruined cities and fortresses.",
        "D": "Diverse landscapes from deserts to jungles.",
        "E": "Enchanted towns and magical realms.",
        "F": "Historical Japan with a supernatural twist."
      }
    },
    {
      question: "What kind of team would you prefer to be part of?",
      img :"https://imgix.ranker.com/list_img_v2/3447/2743447/original/strongest-anime-teams",
      OPTIONS: {
        "A": "A diverse crew with unique abilities.",
        "B": "Close-knit friends who become family.",
        "C": "A military squad or regiment.",
        "D": "A group of skilled hunters and adventurers.",
        "E": "A guild full of magical users.",
        "F": "A group of demon slayers with special powers."
      }
    },
    {
      question: "What type of power or ability would you want?",
      img:"https://i.pinimg.com/736x/9f/67/47/9f67472b89e3dc96456f268eb50be520.jpg",
      OPTIONS: {
        "A": "Superhuman strength and agility.",
        "B": "Control over powerful elemental forces.",
        "C": "Advanced combat skills and strategic thinking.",
        "D": "The ability to use aura or nen.",
        "E": "Mastery of magic and spells.",
        "F": "Specialized breathing techniques and swordsmanship."
      }
    },
    {
      question: "How do you handle conflicts?",
      img:"https://thechuunicorner.com/wp-content/uploads/2016/02/eba1yrv.png",
      OPTIONS: {
        "A": "Head-on with a fearless attitude.",
        "B": "By protecting and shielding those you care about.",
        "C": "Strategically, with careful planning and execution.",
        "D": "With adaptability and clever tactics.",
        "E": "Using your magical abilities to outwit opponents.",
        "F": "With relentless determination and focus."
      }
    },
    {
      question: "What's your ideal adventure?",
      img:"https://wallpaper.forfun.com/fetch/62/62fc16400038ae6220d7aaded74f6db4.jpeg",
      OPTIONS: {
        "A": "Sailing the seas.",
        "B": "Training and growing stronger with each challenge.",
        "C": "Fighting to protect humanity from extinction.",
        "D": "Exploring dangerous and mysterious lands.",
        "E": "Engaging in epic magical battles.",
        "F": "Hunting down and defeating demons."
      }
    },
    {
      question: "Which quality do you value the most in an ally?",
      img:"https://imgix.ranker.com/user_node_img/50127/1002525562/original/1002525562-photo-u2?auto=format&q=60&fit=crop&fm=pjpg&dpr=2&w=375",
      OPTIONS: {
        "A": "Loyalty and courage.",
        "B": "Dedication and perseverance.",
        "C": "Strength and leadership.",
        "D": "Intelligence and resourcefulness.",
        "E": "Creativity and magical prowess.",
        "F": "Bravery and a strong sense of duty."
      }
    },
    {
      question: "How would you describe your personality?",
      img:"https://static0.gamerantimages.com/wordpress/wp-content/uploads/2023/07/collage-maker-31-jul-2023-09-04-pm-7201.jpg",
      OPTIONS: {
        "A": "Bold and adventurous.",
        "B": "Caring and determined.",
        "C": "Strong-willed and tactical.",
        "D": "Curious and adaptable.",
        "E": "Charismatic and magical.",
        "F": "Focused and disciplined."
      }
    },
    {
      question: "What kind of enemies would you prefer to face?",
      img:"https://wallpapers.com/images/hd/samurai-anime-afro-enemies-fight-csext7c1st38xqxm.jpg",
      OPTIONS: {
        "A": "Diverse villian driven by unique motivations.",
        "B": "Powerful foes with complex characters.",
        "C": "Gigantic, monstrous creatures.",
        "D": "Dangerous beasts and hunters.",
        "E": "Dark wizards and magical creatures.",
        "F": "Demons and supernatural entities."
      }
    },
    {
      question: "Which type of challenges excite you the most?",
      img:"https://static1.cbrimages.com/wordpress/wp-content/uploads/2021/08/Bakugo-kenpachi-netero.jpg",
      OPTIONS: {
        "A": "Dynamic battles with instense combat.",
        "B": "Epic Battles and training arcs.",
        "C": "Battling titanic enemies and strategic warfare.",
        "D": "Surviving dangerous hunts and missions.",
        "E": "Mastering magic and facing enchanted foes.",
        "F": "Fighting against overwhelming demonic forces."
      }
    },
    {
      question: "How do you prefer to travel on your adventures?",
      img:"https://media.gqindia.com/wp-content/uploads/2023/04/Daily-BW-for-April-19-Anime-movies-1920x1080.jpg",
      OPTIONS: {
        "A": "On a ship with your crew.",
        "B": "Through forests and secrets paths.",
        "C": "Within fortified walls or open battlegrounds.",
        "D": "Across various terrains and regions.",
        "E": "Using magical portals or on foot.",
        "F": "On foot or with traditional transport."
      }
    },
    {
      question: "What kind of backstory would you have?",
      img:"https://static1.cbrimages.com/wordpress/wp-content/uploads/2022/05/itachi-tomura-isabella-villains-tragic-backstory-cover-image.jpg",
      OPTIONS: {
        "A": "A dream to explore vast unknown world.",
        "B": "A desire to become the strongest.",
        "C": "A mission to protect humanity from extinction.",
        "D": "A quest to uncover the secrets of the world.",
        "E": "A journey to master magic and defeat evil.",
        "F": "A vow to rid the world of demons."
      }
    },
    {
      question: "What's your greatest strength?",
      img:"https://assets-prd.ignimgs.com/2022/08/17/top25animecharacters-blogroll-1660777571580.jpg",
      OPTIONS: {
        "A": "Courage and determination.",
        "B": "Resilience and loyalty.",
        "C": "Strategic mind and combat prowess.",
        "D": "Adaptability and intelligence.",
        "E": "Magical talent and creativity.",
        "F": "Steadfastness and a strong moral compass."
      }
    },
    {
      question: "Which phrase resonates with you the most?",
      img:"https://static1.cbrimages.com/wordpress/wp-content/uploads/2022/05/Best-Anime-Catchphrases-featured-image.jpg",
      OPTIONS: {
        "A": "Let's go for adventure!",
        "B": "Believe in the power of bonds.",
        "C": "Fight for humanity's future.",
        "D": "Seek and you shall find.",
        "E": "Magic is the key to victory.",
        "F": "Protect the innocent from darkness."
      }
    },
    {
      question: "What kind of legacy would you want to leave behind?",
      img:"https://static1.cbrimages.com/wordpress/wp-content/uploads/2022/05/Best-Anime-Catchphrases-featured-image.jpg",
      OPTIONS: {
        "A": "A legend known across the seas.",
        "B": "Stories of heroic deeds.",
        "C": "A legacy of bravery against overwhelming odds.",
        "D": "Tales of great discoveries.",
        "E": "Fables of magical heroism and triumph.",
        "F": "A saga of defeating evil and protecting the weak."
      }
    },
    {
      question: "How do you handle teamwork?",
      img:"https://animemonographia.wordpress.com/wp-content/uploads/2013/12/vlcsnap-2013-12-25-20h20m32s146.png",
      OPTIONS: {
        "A": "As a bold leader or inspiring captain.",
        "B": "As a supportive and dependable member.",
        "C": "As a strategic planner and motivator.",
        "D": "As a resourceful and versatile participant.",
        "E": "As a key magical force and team player.",
        "F": "As a disciplined and focused fighter."
      }
    },
    {
      question: "What is your favorite type of scenery?",
      img:"https://w0.peakpx.com/wallpaper/156/172/HD-wallpaper-anime-scenery-sakura-art-anime-village-orginal-scenery.jpg",
      OPTIONS: {
        "A": "Endless blue seas and islands.",
        "B": "Lush forests and serene mountains.",
        "C": "Vast, desolate landscapes and fortified towns.",
        "D": "Diverse terrains from jungles to deserts.",
        "E": "Enchanted castles and magical forests.",
        "F": "Traditional villages and haunted mountains."
      }
    },
    {
      question: "What would be your ultimate goal?",
      img:"https://imgix.ranker.com/user_node_img/83/1647832/original/1647832-photo-u85?auto=format&q=60&fit=crop&fm=pjpg&dpr=2&w=375",
      OPTIONS: {
        "A": "To become the known across the vast seas and islands.",
        "B": "To become the strongest in the land.",
        "C": "To protect humanity from extinction.",
        "D": "To discover the world's greatest secrets.",
        "E": "To master magic and defeat dark forces.",
        "F": "To eradicate demons and protect humanity."
      }
    },
    {
      question: "Which challenge would you find most rewarding?",
      img:"https://static0.gamerantimages.com/wordpress/wp-content/uploads/2023/11/best-martial-arts-anime-of-all-time.jpg",
      OPTIONS: {
        "A": "Finding the ultimate treasure.",
        "B": "Completing rigorous ninja training and missions.",
        "C": "Defeating enemies and saving the world.",
        "D": "Overcoming the most dangerous hunts.",
        "E": "Winning against powerful magical foes.",
        "F": "Vanquishing powerful demons."
      }
    },
  
  ];

  export default adventureAnime;